export default __webpack_public_path__ + "static/media/blockchain-lock-1-30-min.829ee867.png";